(function() { window.GUID_ff6a67e5_2c89_4ce9_8997_02f81ffed250 = { getGuid: function() { return "ff6a67e5-2c89-4ce9-8997-02f81ffed250"; } }; })();
var CS;
(function (CS) {
    /**
     * Compresses and decompresses string representation of filters.
     * Using Base64 encoding is not an option because it contains characters that are not allowed in URL.
     * Using URL encoding on the Base64 encoded string is not an option because it makes the URL too long and defeats the purpose of compressing.
     * Also, we need to manipulate the string in the client side. Using Base64 encoding would require an external library, which is not ideal.
     * So, we are using a custom compression algorithm that, after some testing, seems to work even better than Base64 encoding on the filters string
     * since it is predictable.
     *
     * WARNING: Any changes to this class should also be implemented in the server side's version of this class.
     */
    class FiltersStringCompressor {
        constructor() { }
        static compress(str) {
            for (const key in FiltersStringCompressor.replacements) {
                str = str.split(key).join(FiltersStringCompressor.replacements[key]);
            }
            return str;
        }
        static decompress(str) {
            for (const key in FiltersStringCompressor.replacements) {
                str = str.split(FiltersStringCompressor.replacements[key]).join(key);
            }
            return str;
        }
    }
    FiltersStringCompressor.replacements = {
        '"SubContext":': "sct_",
        '"Context":': "ctx_",
        '"FilterItems":': "fi_",
        '"SortItems":': "si_",
        '"CollapsedLayout":': "cl_",
        '"Type":': "ty_",
        '"IsVisible":': "iv_",
        '"Value":': "va_",
        '"IsActive":': "ia_",
        '"Direction":': "di_",
        '"IsSelected":': "is_",
        true: "t1",
        false: "t0",
        "}": ")",
        "{": "(",
        ",": "!",
        '"': "*",
    };
    CS.FiltersStringCompressor = FiltersStringCompressor;
})(CS || (CS = {}));

//# sourceMappingURL=FiltersStringCompressor.js.map
